import  {Component} from 'react';
import axios from "axios";
import {apiConfigs,headers } from '../configs';
class Api extends Component {
    constructor(props) {
        super(props);
        axios.defaults.baseURL = apiConfigs.baseURL;
        axios.defaults.timeout = 125000;
    }

    getAgents = () => {
        return axios.get( `webservice2/agent`, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    getContactInfo = () => {
        return axios.get( `webservice2/contact`, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    getNews = () => {
        return axios.get( `webservice2/news`, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    getGuide = () => {
        return axios.get( `webservice2/guide`, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    getCarData = (mobile,password) => {
        return axios.get( `webservice2/act-ws/${mobile}/${password}`, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    changePass = (mobile,password) => {
        return axios.get( `webservice2/npas/${mobile}/${password}`, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    SaveCar = (params) => {
        return axios.post( `webservice2/save_car`, params , {headers})
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    socketSendData = (request) => {
        return axios.get( `webservice2/socket/?type=send&
        mobile=${request.mobile}&
        device=${request.device}&
        password=${request.password}&
        command=${request.command}&
        
        `, {
            headers
        })

    }
    socketRegister = (request) => {

        return axios.get( `webservice2/socket/?type=reg&
        mobile=${request.mobile}&
        device=${request.device}&
        password=${request.password}&
        command=${request.command}&
        
        `, {
            headers
        })

    }

    getContent = (slug) => {
        return axios.get( `v1/contents/${slug}`, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }



    updateVehicles = (request , id) => {
        return axios.post( `webservice2/rename-wa`, request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    deleteVehicles = (request , id) => {
        return axios.post( `webservice2/remove-car-wa`, request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }


}
const API = new Api();
export default API;